import { publicClient, privateClient } from './client';
import { AssignedPromotionCode } from './AssignedPromotionCode';

const transactionsAssignedPromotionCode = (pub: boolean) => new AssignedPromotionCode(pub ? publicClient : privateClient);
export default transactionsAssignedPromotionCode;
